import { roles } from "shared/constants/Constants";

const tallyRoutes = {
  dashboard: [
    {
      path: "cash_transfers",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "cash-transfers" */
          "feature/tally/dashboard/TransferFund.js"
        ),
      authorized: [roles.ADMIN, roles.FINANCE],
      sidebarGroup: "tallyList",
      sidebarLabel: "Transfers",
    },
    {
      path: "cash_requests",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "cash-requests" */
          "feature/tally/dashboard/CashRequests.js"
        ),
      authorized: [roles.HUB_MANAGER, roles.ADMIN, roles.FINANCE],
      sidebarGroup: "tallyList",
      sidebarLabel: "Request Cash",
    },
    {
      path: "cheque_requests",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "cheque-requests" */
          "feature/tally/dashboard/ChequeRequests.js"
        ),
      authorized: [roles.HUB_MANAGER, roles.ADMIN, roles.FINANCE],
      sidebarGroup: "tallyList",
      sidebarLabel: "Request Cheque",
    },
    {
      path: "ledger",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "ledger" */
          "feature/driver/dashboard/ledger/NewLedger.js"
        ),
      authorized: [roles.FINANCE, roles.HUB_MANAGER, roles.ADMIN],
      sidebarGroup: "tallyList",
      sidebarLabel: "Ledger",
    },
    {
      path: "cheque_submitted",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "cheque-submitted" */
          "feature/tally/dashboard/ChequeSubmitted.js"
        ),
      authorized: [
        roles.HUB_MANAGER,
        roles.ONBOARDING,
        roles.DRIVER_MANAGER,
        roles.SENIOR_DRIVER_MANAGER,
      ],
      sidebarGroup: "tallyList",
      sidebarLabel: "Submitted Cheque",
    },
    {
      path: "cheque_wallet",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "cheque-wallet" */
          "feature/tally/dashboard/ChequeWallet.js"
        ),
      authorized: [
        roles.HUB_MANAGER,
        roles.ONBOARDING,
        roles.DRIVER_MANAGER,
        roles.SENIOR_DRIVER_MANAGER,
      ],
      sidebarGroup: "tallyList",
      sidebarLabel: "Wallet Cheque",
    },
    {
      path: "cash_wallet",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "cash-wallet" */
          "feature/tally/dashboard/CashWallet.js"
        ),
      authorized: [
        roles.HUB_MANAGER,
        roles.ONBOARDING,
        roles.DRIVER_MANAGER,
        roles.SENIOR_DRIVER_MANAGER,
      ],
      sidebarGroup: "tallyList",
      sidebarLabel: "Wallet Cash",
    },

    {
      path: "cash_submitted",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "cash-submitted" */
          "feature/tally/dashboard/CashSubmitted.js"
        ),
      authorized: [
        roles.HUB_MANAGER,
        roles.ONBOARDING,
        roles.DRIVER_MANAGER,
        roles.SENIOR_DRIVER_MANAGER,
      ],
      sidebarGroup: "tallyList",
      sidebarLabel: "Submitted Cash",
    },
  ],
  standalone: [
    {
      path: "/tally/:tallyId/:type",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "tally-detail" */
          "feature/tally/dashboard/TallyDetail"
        ),
      protected: true,
    },
  ],
};

export default tallyRoutes;
